import Component from 'antd/es/popover';
import 'antd/lib/popover/style';
export default Component;
